import { makeStyles } from 'tss-react/mui';
export default makeStyles()(function (theme) {
  var borderColor = theme.palette.primary[900];
  return {
    root: {
      '& .MuiInputBase-root:not(.Mui-error)': {
        fontFamily: 'inherit',
        borderColor: borderColor
      },
      '& label:not(.Mui-error).Mui-focused': {
        color: borderColor
      },
      '& .MuiInput-underline:not(.Mui-error):hover:before': {
        borderBottomColor: borderColor
      },
      '& .MuiInput-underline:not(.Mui-error):after': {
        borderBottomColor: borderColor
      },
      '& .MuiFilledInput-underline:not(.Mui-error):hover:before': {
        borderBottomColor: borderColor
      },
      '& .MuiFilledInput-underline:not(.Mui-error):after': {
        borderBottomColor: borderColor
      },
      '& .MuiOutlinedInput-root:not(.Mui-error)': {
        '&:hover fieldset': {
          borderColor: borderColor
        },
        '&.Mui-focused fieldset': {
          borderColor: borderColor
        }
      },
      '& input': {
        paddingTop: '18px',
        paddingBottom: '18px',
        borderBottomColor: borderColor
      },
      '& .MuiOutlinedInput-adornedEnd': {
        paddingRight: '0px!important'
      },
      '& .MuiInputAdornment-positionEnd button': {
        visibility: 'hidden',
        backgroundColor: 'transparent !important'
      },
      '&:hover .MuiInputAdornment-positionEnd button, .Mui-focused .MuiInputAdornment-positionEnd button': {
        visibility: 'visible',
        backgroundColor: 'transparent !important'
      }
    },
    errorIcon: {
      paddingRight: '9px',
      '& path': {
        color: theme.palette.error.main
      }
    }
  };
});